module.exports = __webpack_public_path__ + "static/media/todo.769bbd0d.png";